import React from 'react'

import styles from './ExceptionWelcomeForm.module.scss'

interface IProps {
  code: string
  domain: string
  group?: string
}

export const ReadOnlyExceptionInfo = ({ code, domain, group }: IProps) => {
  return (
    <div className={styles.dropdownMobile}>
      <p className={styles.dropdownMobile__label}>Exception Domain: {domain ? '' : '-'}</p>
      {domain ? <p className={styles.dropdownMobile__value}>{domain}</p> : null}

      <p className={styles.dropdownMobile__label}>Exception Group: {group ? '' : '-'}</p>
      {group ? <p className={styles.dropdownMobile__value}>{group}</p> : null}

      <p className={styles.dropdownMobile__label}>Exception Reason: {code ? '' : '-'}</p>
      {code ? <p className={styles.dropdownMobile__value}>{code}</p> : null}
    </div>
  )
}
